export default __webpack_public_path__ + "static/media/arrow-dir-2.886e6a8a.gif";